import PropTypes from 'prop-types'
import React from 'react'
const IconType = { regular: 'far', solid: 'fas', light: 'fal', duotone: 'fad', far: 'far', fas: 'fas', fal: 'fal', fad: 'fad' }

const FontAwesomeIcon = ({ icon, type, title, onClick, style, className }) => (
  <i title={title} className={`${IconType[type]} fa-${icon} ${className}`} onClick={onClick} style={style} />
)

FontAwesomeIcon.defaultProps = {
  type: 'regular',
  title: '',
  onClick: () => undefined
}

FontAwesomeIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  type: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
}

export default FontAwesomeIcon
